import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import productsData from "../../data/products.json";
import "./Products.css";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const category = searchParams.get("category");

  useEffect(() => {
    if (!category) return;

    // const filteredProducts = productsData.filter(
    //   (p) => p.category_name === category
    // );

    const filteredProducts = productsData.filter(
  (p) =>
    p.category_name.trim().toLowerCase() ===
    decodeURIComponent(category).trim().toLowerCase()
);

    setProducts(filteredProducts);
  }, [category]);

  if (!category) {
    return <h2 className="no-category">Please Select Product Category</h2>;
  }

  return (
    <div className="products-page">
      <h2 className="category-title">{category}</h2>

      {products.length === 0 ? (
        <p className="no-products">No products found</p>
      ) : (
        <div className="products-grid">
          {products.map((p) => (
            <div className="product-card" key={p.product_id}>
              
              <div className="product-image">
                <img src={p.images?.[0]} alt={p.name} />
              </div>

              <h3 className="product-name">{p.name}</h3>

              <button
                className="info-btn"
                onClick={() => navigate(`/product/${p.product_id}`)}
              >
                Info
              </button>

            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Products;